import React from 'react';
import { Box } from '@mui/material';

/**
 * Selector de Áreas / Roles en forma de píldoras
 */
const GestorAreaSelector = ({ areaOptions, currentArea, onSelectArea }) => {
  return (
    <Box
      role="group"
      aria-label="Área"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
      }}
    >
      {areaOptions.map((opt) => {
        const isActive = currentArea === opt.id;
        return (
          <Box
            component="button"
            key={opt.id}
            type="button"
            onClick={() => onSelectArea(opt.id)}
            aria-pressed={isActive}
            sx={{
              minHeight: '44px',
              padding: '0 20px',
              borderRadius: '999px',
              border: '1px solid',
              borderColor: isActive ? 'primary.main' : '#C9D2DD',
              backgroundColor: isActive ? 'primary.main' : '#FFFFFF',
              color: isActive ? '#FFFFFF' : '#3A4352',
              fontFamily: (theme) => theme.typography.h1.fontFamily,
              fontSize: isActive ? '16px' : '15px',
              fontWeight: isActive ? 600 : 500,
              cursor: 'pointer',
              transition: 'all 0.15s ease',
              boxShadow: isActive ? '0 2px 8px rgba(0, 154, 218, 0.25)' : 'none',
              '&:hover': {
                backgroundColor: isActive ? 'primary.main' : '#F8FAFC',
                borderColor: isActive ? 'primary.main' : '#B0BAC7',
              },
              '&:focus-visible': {
                outline: '3px solid #8FD0F2',
                outlineOffset: '2px',
              },
            }}
          >
            {opt.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default GestorAreaSelector;
